<template>
  <el-dropdown
    class="login-dropdown-link"
    placement="top-end"
    @visible-change="dropdownChange"
    trigger="click"
  >
    <span class="dropdown-link" @click="click">
      <span>Hola，<slot></slot></span>
      <i
        :class="['icon-outlinedpickup', { 'is-rotate': personalCenterShow }]"
      ></i>
    </span>

    <el-dropdown-menu class="login-user-dropdown-menu">
      <div class="list">
        <el-dropdown-item
          v-for="(item, i) in list"
          :key="i"
          :icon="item.icon"
          @click.native="action(item)"
        >
          <span class="dropdown-item-content">{{ item.content }}</span>
        </el-dropdown-item>
      </div>
      <el-dropdown-item divided @click.native="signout">{{
        $t('Entrega_order__uvJi' /** 退出 */)
      }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import {
  topNavClick,
  topUserCenterView,
  topUserCenterClick,
} from '@/omega/business/common';
export default {
  components: {},
  name: 'UserCenter',
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {},
  data() {
    return {
      personalCenterShow: false,
    };
  },
  mounted() {},
  methods: {
    signout() {
      this.$emit('signout');
      topUserCenterClick({ click_type: 1 });
    },
    dropdownChange(status) {
      this.personalCenterShow = status;
      status && topUserCenterView();
    },
    action(item) {
      topUserCenterClick({ click_type: item.type });
      this.$emit('action', item);
    },
    click() {
      topNavClick({ click_type: 1 });
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdown-link {
  display: block;
  height: 18px;
  line-height: 18px;
  font-family: 'DiDiSansPro-Medium';
  font-size: 14px;
  font-weight: 500;
  color: #000;
  cursor: pointer;

  // 主题配置
  [data-site-theme='dark'] & {
    color: #fff;
  }
}
.dropdown-link span {
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
}
.dropdown-link i {
  margin-left: 4px;
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
  transform: rotate(0);
  transition: all 0.3s ease;
}

.dropdown-link .is-rotate {
  transform: rotate(-180deg);
}
</style>

<style lang="scss">
.login-user-dropdown-menu {
  width: 216px;
  &.el-dropdown-menu {
    padding: 0px;
    border: 0 !important;
    margin-top: 28px !important;
  }

  .list {
    padding: 7px 0;
  }

  .el-dropdown-menu__item {
    line-height: 44px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }

  > i {
    margin-right: 8px;
  }

  .el-dropdown-menu__item--divided {
    margin-top: 0;
    justify-content: center;

    &::before {
      display: none;
    }
  }
}
</style>
